import { createContext } from "react";

const EncuestasEvaluacionesContext = createContext();

export default EncuestasEvaluacionesContext;
